import { Button, message, Upload } from "antd";
import { useDispatch } from "react-redux";
import { authAction } from "hooks/actions/mainAction";
import s3Controller from "controllers/s3Controller";

const backend = process.env.REACT_APP_BACKEND;

const PictureUpload = () => {
  const dispatch = useDispatch();
  const props = {
    name: "file",
    action: `${backend}/userInfo/pictureUpload`, // 요청을 보낼 주소
    headers: {},
    accept: "image/*", // 이미지 파일만 선택 가능하도록
    maxCount: 1, // 최대 올릴 수 있는 이미지 제한
    showUploadList: false, // 업로드 리스트를 안보여주도록
    withCredentials: true, // 중요!! 이게 없으면 401에러가 난다.

    onChange(info) {
      // s3Controller.s3Upload(info.file.originFileObj,(err,data)=>{
      //   if (err) console.log(err)
      //   console.log(data)
      // })
      if (info.file.status !== "uploading") {
          console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        message.success(`${info.file.name} file uploaded successfully`);
        dispatch(authAction(true, info.file.response.data));
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };

  return (
    <Upload {...props}>
      <Button>사진 변경</Button>
    </Upload>
  );
};

export default PictureUpload;
